import React from 'react';
import { useParams } from 'react-router-dom';
import Profile from '../components/Profile';
import { useAuth } from '../contexts/AuthContext';

const ProfilePage: React.FC = () => {
  const { userId } = useParams<{ userId?: string }>();
  const { user } = useAuth();
  const currentUserId = user?.id || '';

  return (
    <Profile
      userId={userId}
      currentUserId={currentUserId}
      isOwnProfile={!userId || userId === currentUserId}
    />
  );
};

export default ProfilePage;